"use client";

import { c as _c } from "react/compiler-runtime";
import { ProgressBarLink } from "@/components/progress-bar";
import NewBadge from "@/components/ui/new-badge";
import { SidebarMenuButton, SidebarMenuItem, SidebarMenuSubButton, SidebarMenuSubItem, useSidebar } from "@/components/ui/sidebar";
import { SiteMapItem } from "@/config/sitemap";
import { usePatientStatus } from "@/hooks/use-patient-status";
import { cx } from "@/lib/tailwind-utils";
import { useCombinedNotificationCount } from "@/query/dosespot/dosespot-notifications";
import { useNavigationSidebarOpenStore } from "@/stores/navigation-sidebar-store";
import { useNotificationsDrawerStore } from "@/stores/notifications-drawer-store";
import { usePatientStatusDrawerStore } from "@/stores/patient-status-drawer-store";
import { useTasksDrawerStore } from "@/stores/tasks-drawer-store";
interface SidebarLeafItemProps {
  item: SiteMapItem;
  currentRoute: string | undefined;
  isSubItem?: boolean;
}

/**
 * Shared component for rendering leaf navigation items (items without children).
 * Used by both top-level nav items and sub-items to reduce duplication.
 */
export function SidebarLeafItem(t0) {
  const $ = _c(99);
  const {
    item,
    currentRoute,
    isSubItem: t1
  } = t0;
  const isSubItem = t1 === undefined ? false : t1;
  const {
    setOpenMobile,
    isMobile
  } = useSidebar();
  let t2;
  if ($[0] !== currentRoute || $[1] !== item.route || $[2] !== item.routeAliases) {
    t2 = currentRoute === item.route || currentRoute !== undefined && item.routeAliases?.includes(currentRoute) === true;
    $[0] = currentRoute;
    $[1] = item.route;
    $[2] = item.routeAliases;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isActive = t2;
  const isNotifications = item.action === "notifications";
  const isPatientStatus = item.action === "patient-status";
  const isTasks = item.action === "tasks";
  let t3;
  if ($[4] !== isNotifications) {
    t3 = state => isNotifications && state.isOpen;
    $[4] = isNotifications;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isNotificationsDrawerOpen = useNotificationsDrawerStore(t3);
  const openNotificationsDrawer = useNotificationsDrawerStore(_temp);
  const closeNotificationsDrawer = useNotificationsDrawerStore(_temp2);
  const openPatientStatusDrawer = usePatientStatusDrawerStore(_temp3);
  const closePatientStatusDrawer = usePatientStatusDrawerStore(_temp4);
  let t4;
  if ($[6] !== isTasks) {
    t4 = state_4 => isTasks && state_4.isOpen;
    $[6] = isTasks;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const isTasksDrawerOpen = useTasksDrawerStore(t4);
  const openTasksDrawer = useTasksDrawerStore(_temp5);
  const closeTasksDrawer = useTasksDrawerStore(_temp6);
  const {
    setHoverOpen
  } = useNavigationSidebarOpenStore();
  const notificationCount = useCombinedNotificationCount();
  if (isNotifications && isMobile) {
    return null;
  }
  let t5;
  if ($[8] !== setHoverOpen || $[9] !== setOpenMobile) {
    t5 = () => {
      setOpenMobile(false);
      setHoverOpen(false);
    };
    $[8] = setHoverOpen;
    $[9] = setOpenMobile;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const closeMobileSidebar = t5;
  let t6;
  if ($[11] !== closeMobileSidebar || $[12] !== isMobile) {
    t6 = () => {
      if (isMobile) {
        closeMobileSidebar();
      }
    };
    $[11] = closeMobileSidebar;
    $[12] = isMobile;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleNavClick = t6;
  let t7;
  if ($[14] !== closeMobileSidebar || $[15] !== closeNotificationsDrawer || $[16] !== closePatientStatusDrawer || $[17] !== closeTasksDrawer || $[18] !== isMobile || $[19] !== isNotificationsDrawerOpen || $[20] !== openNotificationsDrawer) {
    t7 = () => {
      closePatientStatusDrawer();
      closeTasksDrawer();
      if (isNotificationsDrawerOpen) {
        closeNotificationsDrawer();
      } else {
        openNotificationsDrawer();
      }
      if (isMobile) {
        closeMobileSidebar();
      }
    };
    $[14] = closeMobileSidebar;
    $[15] = closeNotificationsDrawer;
    $[16] = closePatientStatusDrawer;
    $[17] = closeTasksDrawer;
    $[18] = isMobile;
    $[19] = isNotificationsDrawerOpen;
    $[20] = openNotificationsDrawer;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const handleNotificationsClick = t7;
  let t8;
  if ($[22] !== closeMobileSidebar || $[23] !== closeNotificationsDrawer || $[24] !== closeTasksDrawer || $[25] !== isMobile || $[26] !== openPatientStatusDrawer) {
    t8 = () => {
      closeNotificationsDrawer();
      closeTasksDrawer();
      openPatientStatusDrawer();
      if (isMobile) {
        closeMobileSidebar();
      }
    };
    $[22] = closeMobileSidebar;
    $[23] = closeNotificationsDrawer;
    $[24] = closeTasksDrawer;
    $[25] = isMobile;
    $[26] = openPatientStatusDrawer;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  const handlePatientStatusClick = t8;
  let t9;
  if ($[28] !== closeMobileSidebar || $[29] !== closeNotificationsDrawer || $[30] !== closePatientStatusDrawer || $[31] !== closeTasksDrawer || $[32] !== isMobile || $[33] !== isTasksDrawerOpen || $[34] !== openTasksDrawer) {
    t9 = () => {
      closeNotificationsDrawer();
      closePatientStatusDrawer();
      if (isTasksDrawerOpen) {
        closeTasksDrawer();
      } else {
        openTasksDrawer();
      }
      if (isMobile) {
        closeMobileSidebar();
      }
    };
    $[28] = closeMobileSidebar;
    $[29] = closeNotificationsDrawer;
    $[30] = closePatientStatusDrawer;
    $[31] = closeTasksDrawer;
    $[32] = isMobile;
    $[33] = isTasksDrawerOpen;
    $[34] = openTasksDrawer;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  const handleTasksClick = t9;
  let t10;
  if ($[36] !== item) {
    t10 = renderAlertBadge(item);
    $[36] = item;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  const alertBadge = t10;
  let t11;
  if ($[38] !== isNotifications || $[39] !== notificationCount) {
    t11 = isNotifications && notificationCount > 0 ? <span className="flex h-5 min-w-5 items-center justify-center rounded-md bg-destructive px-1.5 text-caption font-medium text-destructive-foreground">{notificationCount > 99 ? "99+" : notificationCount}</span> : null;
    $[38] = isNotifications;
    $[39] = notificationCount;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  const notificationBadge = t11;
  const t12 = !isSubItem && "text-caption font-medium uppercase";
  let t13;
  if ($[41] !== t12) {
    t13 = cx("flex-1", t12);
    $[41] = t12;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== item.name || $[44] !== t13) {
    t14 = <span className={t13}>{item.name}</span>;
    $[43] = item.name;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== item.showNewBadge) {
    t15 = item.showNewBadge && <NewBadge />;
    $[46] = item.showNewBadge;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== alertBadge || $[49] !== isPatientStatus || $[50] !== notificationBadge) {
    t16 = isPatientStatus ? <PatientStatusBadge /> : notificationBadge || alertBadge;
    $[48] = alertBadge;
    $[49] = isPatientStatus;
    $[50] = notificationBadge;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== item.icon || $[53] !== t14 || $[54] !== t15 || $[55] !== t16) {
    t17 = <>{t14}{item.icon}{t15}{t16}</>;
    $[52] = item.icon;
    $[53] = t14;
    $[54] = t15;
    $[55] = t16;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  const content = t17;
  if (isSubItem) {
    if (isNotifications) {
      let t18;
      if ($[57] !== content || $[58] !== handleNotificationsClick || $[59] !== isActive) {
        t18 = <SidebarMenuSubItem><SidebarMenuSubButton onClick={handleNotificationsClick} isActive={isActive} className="cursor-pointer">{content}</SidebarMenuSubButton></SidebarMenuSubItem>;
        $[57] = content;
        $[58] = handleNotificationsClick;
        $[59] = isActive;
        $[60] = t18;
      } else {
        t18 = $[60];
      }
      return t18;
    }
    if (isPatientStatus) {
      let t18;
      if ($[61] !== content || $[62] !== handlePatientStatusClick || $[63] !== isActive) {
        t18 = <SidebarMenuSubItem><SidebarMenuSubButton onClick={handlePatientStatusClick} isActive={isActive} className="cursor-pointer">{content}</SidebarMenuSubButton></SidebarMenuSubItem>;
        $[61] = content;
        $[62] = handlePatientStatusClick;
        $[63] = isActive;
        $[64] = t18;
      } else {
        t18 = $[64];
      }
      return t18;
    }
    if (isTasks) {
      let t18;
      if ($[65] !== content || $[66] !== handleTasksClick || $[67] !== isActive) {
        t18 = <SidebarMenuSubItem><SidebarMenuSubButton onClick={handleTasksClick} isActive={isActive} className="cursor-pointer">{content}</SidebarMenuSubButton></SidebarMenuSubItem>;
        $[65] = content;
        $[66] = handleTasksClick;
        $[67] = isActive;
        $[68] = t18;
      } else {
        t18 = $[68];
      }
      return t18;
    }
    const t18 = item.route ?? "#";
    let t19;
    if ($[69] !== content || $[70] !== handleNavClick || $[71] !== t18) {
      t19 = <ProgressBarLink href={t18} onClick={handleNavClick}>{content}</ProgressBarLink>;
      $[69] = content;
      $[70] = handleNavClick;
      $[71] = t18;
      $[72] = t19;
    } else {
      t19 = $[72];
    }
    let t20;
    if ($[73] !== isActive || $[74] !== t19) {
      t20 = <SidebarMenuSubItem><SidebarMenuSubButton asChild={true} isActive={isActive}>{t19}</SidebarMenuSubButton></SidebarMenuSubItem>;
      $[73] = isActive;
      $[74] = t19;
      $[75] = t20;
    } else {
      t20 = $[75];
    }
    return t20;
  }
  if (isNotifications) {
    let t18;
    if ($[76] !== content || $[77] !== handleNotificationsClick || $[78] !== isActive || $[79] !== item.name) {
      t18 = <SidebarMenuItem><SidebarMenuButton onClick={handleNotificationsClick} isActive={isActive} tooltip={item.name}>{content}</SidebarMenuButton></SidebarMenuItem>;
      $[76] = content;
      $[77] = handleNotificationsClick;
      $[78] = isActive;
      $[79] = item.name;
      $[80] = t18;
    } else {
      t18 = $[80];
    }
    return t18;
  }
  if (isPatientStatus) {
    let t18;
    if ($[81] !== content || $[82] !== handlePatientStatusClick || $[83] !== isActive || $[84] !== item.name) {
      t18 = <SidebarMenuItem><SidebarMenuButton onClick={handlePatientStatusClick} isActive={isActive} tooltip={item.name}>{content}</SidebarMenuButton></SidebarMenuItem>;
      $[81] = content;
      $[82] = handlePatientStatusClick;
      $[83] = isActive;
      $[84] = item.name;
      $[85] = t18;
    } else {
      t18 = $[85];
    }
    return t18;
  }
  if (isTasks) {
    let t18;
    if ($[86] !== content || $[87] !== handleTasksClick || $[88] !== isActive || $[89] !== item.name) {
      t18 = <SidebarMenuItem><SidebarMenuButton onClick={handleTasksClick} isActive={isActive} tooltip={item.name}>{content}</SidebarMenuButton></SidebarMenuItem>;
      $[86] = content;
      $[87] = handleTasksClick;
      $[88] = isActive;
      $[89] = item.name;
      $[90] = t18;
    } else {
      t18 = $[90];
    }
    return t18;
  }
  const t18 = item.route ?? "#";
  let t19;
  if ($[91] !== content || $[92] !== handleNavClick || $[93] !== t18) {
    t19 = <ProgressBarLink href={t18} onClick={handleNavClick}>{content}</ProgressBarLink>;
    $[91] = content;
    $[92] = handleNavClick;
    $[93] = t18;
    $[94] = t19;
  } else {
    t19 = $[94];
  }
  let t20;
  if ($[95] !== isActive || $[96] !== item.name || $[97] !== t19) {
    t20 = <SidebarMenuItem><SidebarMenuButton asChild={true} isActive={isActive} tooltip={item.name}>{t19}</SidebarMenuButton></SidebarMenuItem>;
    $[95] = isActive;
    $[96] = item.name;
    $[97] = t19;
    $[98] = t20;
  } else {
    t20 = $[98];
  }
  return t20;
}
function _temp6(state_6) {
  return state_6.closeDrawer;
}
function _temp5(state_5) {
  return state_5.openDrawer;
}
function _temp4(state_3) {
  return state_3.closeDrawer;
}
function _temp3(state_2) {
  return state_2.openDrawer;
}
function _temp2(state_1) {
  return state_1.closeDrawer;
}
function _temp(state_0) {
  return state_0.openDrawer;
}
function PatientStatusBadge() {
  const $ = _c(2);
  const {
    numEntries
  } = usePatientStatus();
  if (numEntries <= 0) {
    return null;
  }
  const t0 = numEntries > 99 ? "99+" : numEntries;
  let t1;
  if ($[0] !== t0) {
    t1 = <span className="flex h-5 min-w-5 items-center justify-center rounded-md bg-destructive px-1.5 text-caption font-medium text-destructive-foreground">{t0}</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

/**
 * Render alert badge based on item type and alert count.
 */
function renderAlertBadge(item: SiteMapItem) {
  if (item.alertCount === undefined) return null;
  return item.alertCount > 0 ? <span className="flex h-5 min-w-5 items-center justify-center rounded-md bg-destructive px-1.5 text-caption font-medium text-destructive-foreground">
      {item.alertCount}
    </span> : null;
}
export { renderAlertBadge };